import * as React from "react";

function IconUmbrella({
  size = 24,
  color = "currentColor",
  stroke = 2,
  ...props
}) {
  return <svg className="icon icon-tabler icon-tabler-umbrella" width={size} height={size} viewBox="0 0 24 24" strokeWidth={stroke} stroke={color} fill="none" strokeLinecap="round" strokeLinejoin="round" {...props}><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M4 12a8 8 0 0 1 16 0Z" /><path d="M12 12v6a2 2 0 0 0 4 0" /></svg>;
}

export default IconUmbrella;